import { Loader } from '../../../shared/ui';
import { useSelector, useDispatch } from 'react-redux';
import { callModel } from '../../call/model';

import { EmptyState, EmptyStateText } from '../';

import { Pagination } from '../../../pages/pages-overview/ui/components/Pagination';

import { CallsGrid, CallsList } from './CallsView';

import { useCallsView } from '../hooks';
import { cn } from '@distribute/frontend/utils';

export const Calls = () => {
  const dispatch = useDispatch();

  const { view } = useCallsView();

  const callList = useSelector(callModel.selectors.selectCalls);
  const callListMeta = useSelector(callModel.selectors.selectCallListMeta);

  const hasOnlyTeamCalls = useSelector(
    callModel.selectors.selectHasOnlyTeamCalls
  );

  const isCallListLoading = useSelector(
    callModel.selectors.selectIsCallListLoading
  );

  const isCallListEmpty = callList.length === 0;

  const handleChangePage = (page: number) => {
    dispatch(
      callModel.actions.setListMeta({
        ...callListMeta,
        currentPage: page,
      })
    );
    dispatch(callModel.actions.loadCalls());
  };

  return (
    <>
      {isCallListLoading ? (
        <div className="flex-grow-1 flex items-center justify-center">
          <Loader />
        </div>
      ) : isCallListEmpty ? (
        <div className="flex-grow-1 flex items-center justify-center">
          <EmptyState
            description={
              hasOnlyTeamCalls
                ? EmptyStateText.personalCalls
                : EmptyStateText.filter
            }
          />
        </div>
      ) : view === 'grid' ? (
        <CallsGrid calls={callList} />
      ) : (
        <CallsList calls={callList} />
      )}
      <div
        className={cn('-mx-1 flex justify-center', {
          hidden: (callListMeta.totalPages ?? 0) <= 1,
        })}
      >
        <Pagination
          isHideIfOnlyOnePage
          className="flex-grow-1"
          currentPage={callListMeta.currentPage}
          lastPage={callListMeta.totalPages ?? 0}
          maxLength={5} // max number of pages to show
          setCurrentPage={handleChangePage}
        />
      </div>
    </>
  );
};
